<div class="d-flex justify-content-center" [class.is-bare]="!showChatFrame">
  <div class="phone-shell position-relative">
    <div class="phone-screen">
      <div class="w-100 h-100 d-flex flex-column">
        @if (showChatFrame) {
          <div
            class="chat-header d-flex align-items-center justify-content-between px-2 py-1"
          >
            <div class="d-flex align-items-center gap-2">
              <div class="avatar rounded-circle">
                <img
                  [src]="avatarUrl"
                  [alt]="'shared.chatWaPreview.userImageAlt' | translate"
                  class="img-fluid avatar-sm rounded-circle"
                />
              </div>
              <div class="d-flex flex-column text-start mt-1">
                <span class="fs-5 fw-bold text-truncate">{{
                  "shared.chatWaPreview.contactNameSample" | translate
                }}</span>
                <small>{{ "shared.chatWaPreview.online" | translate }}</small>
              </div>
            </div>

            <div class="d-flex align-items-center gap-2">
              <i class="fw-bold fs-3 mdi mdi-dots-vertical"></i>
            </div>
          </div>
        }
        <div class="flex-grow-1 w-100 scroll d-flex flex-column-reverse">
          <div class="chat-container bg-image p-2">
            <div class="chat-bubble">
              @if (title) {
                <div class="w-100 content-title mb-2">
                  <span
                    class="ps-3 text-truncate text-dark fw-bold fs-5 text-nowrap"
                  >
                    {{ title }}
                  </span>
                </div>
              }
              @switch (templateType) {
                @case ("button") {
                  <div class="d-flex flex-column">
                    <span class="ps-3 text-dark fw-semibold fs-5">
                      {{
                        message ??
                          ("shared.chatWaPreview.messagePlaceholder"
                            | translate)
                      }}
                    </span>
                    <div
                      class="w-100 d-flex align-items-end justify-content-between"
                    >
                      @if (footer) {
                        <div class="ps-3 max-w-230">
                          <span class="text-muted fs-5">
                            {{ footer }}
                          </span>
                        </div>
                      }
                      <div
                        class="w-100 d-flex align-items-center justify-content-end"
                      >
                        <span class="text-muted fw-semibold fs-6 text-end">
                          {{ currentTime }}
                        </span>
                      </div>
                    </div>
                  </div>
                  @if (buttons.length > 0) {
                    <div class="d-flex flex-column gap-2 mt-1 border-top">
                      @for (button of buttons; track button) {
                        <div class="buttons-section border-top pt-1">
                          @switch (button.type) {
                            @case (ButtonActionsTypeEnum.reply) {
                              <i class="mdi mdi-reply text-success fs-6"></i>
                            }
                            @case (ButtonActionsTypeEnum.call) {
                              <i class="mdi mdi-phone text-success fs-6"></i>
                            }
                            @case (ButtonActionsTypeEnum.url) {
                              <i class="mdi mdi-link text-success fs-6"></i>
                            }
                          }
                          <span class="label-button text-success fs-5">
                            {{ button.label }}
                          </span>
                        </div>
                      }
                    </div>
                  }
                }
                @case ("text") {
                  <div class="d-flex flex-column">
                    @if (mediaSrc) {
                      <div class="mb-2">
                        <img
                          [src]="mediaSrc"
                          [alt]="
                            'shared.chatWaPreview.mediaContentAlt' | translate
                          "
                          class="img-fluid"
                        />
                      </div>
                    }
                    <span class="text-dark fw-semibold fs-5">
                      {{
                        message ??
                          ("shared.chatWaPreview.messagePlaceholder"
                            | translate)
                      }}
                    </span>

                    <div
                      class="w-100 d-flex align-items-end justify-content-between"
                    >
                      @if (footer) {
                        <div class="max-w-230">
                          <span class="text-muted fs-5">
                            {{ footer }}
                          </span>
                        </div>
                      }
                      <div
                        class="w-100 d-flex align-items-center justify-content-end"
                      >
                        <span class="text-muted fw-semibold fs-6 text-end">
                          {{ currentTime }}
                        </span>
                      </div>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
